import React from 'react';
import { TripDisplayStatus } from '../types';

// Frosted pill with a colored dot. The single merged status (resolveDisplayStatus):
// temporal facts (now/past) win, otherwise the user-set stage. `now` pulses.

const CONFIG: Record<TripDisplayStatus, { label: string; color: string; pulse?: boolean }> = {
  now: { label: 'Happening now', color: '#157a55', pulse: true },
  past: { label: 'Past trip', color: '#6c7872' },
  idea: { label: 'Idea', color: '#8a6fb0' },
  organizing: { label: 'Organizing', color: '#2f6f9e' },
  booked: { label: 'Booked', color: '#0e7c86' },
};

export interface StatusPillProps {
  status: TripDisplayStatus;
}

const StatusPill: React.FC<StatusPillProps> = ({ status }) => {
  const cfg = CONFIG[status];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 10px',
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 600,
        color: cfg.color,
        background: 'rgba(255,255,255,0.82)',
        backdropFilter: 'blur(4px)',
        boxShadow: '0 1px 2px rgba(20,40,30,0.08)',
      }}
    >
      <span
        style={{
          width: 7,
          height: 7,
          borderRadius: 999,
          background: cfg.color,
          boxShadow: cfg.pulse ? `0 0 0 0 ${cfg.color}` : undefined,
          animation: cfg.pulse ? 'jodyPulse 1.8s ease-out infinite' : undefined,
        }}
      />
      {cfg.label}
      {cfg.pulse && (
        <style>{`@keyframes jodyPulse {0%{box-shadow:0 0 0 0 rgba(21,122,85,0.5)}70%{box-shadow:0 0 0 6px rgba(21,122,85,0)}100%{box-shadow:0 0 0 0 rgba(21,122,85,0)}}`}</style>
      )}
    </span>
  );
};

export default StatusPill;
